import { render, staticRenderFns } from "./ApprovalDeleteModal.vue?vue&type=template&id=7f39773b&scoped=true&"
import script from "./ApprovalDeleteModal.vue?vue&type=script&lang=js&"
export * from "./ApprovalDeleteModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f39773b",
  null
  
)

export default component.exports